import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { MapPin, LineChart, ShieldCheck, Users } from "lucide-react";
import { IMAGES, EASE } from "./constants";

const REASONS = [
  { icon: MapPin, title: "Conoscenza del territorio", body: "Milano città e provincia: valutiamo il tuo immobile sui dati reali del tuo quartiere." },
  { icon: LineChart, title: "Prezzo corretto, subito", body: "Un&rsquo;analisi di mercato onesta per vendere nei tempi giusti, senza svendere." },
  { icon: Users, title: "Rete di acquirenti", body: "Un portafoglio selezionato di clienti pronti ad acquistare a Milano." },
  { icon: ShieldCheck, title: "Tutela in ogni fase", body: "Assistenza notarile, tecnica e burocratica dall&rsquo;incarico al rogito." },
];

export const WhyUs = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15%" });

  return (
    <section ref={ref} data-testid="why-us-section" className="relative py-24 md:py-36 bg-[#2E3131] text-[#F5F6F2] overflow-hidden">
      <div className="absolute inset-0 opacity-15">
        <img src={IMAGES.facade} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#2E3131]/70" />
      </div>

      <div className="relative max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="overline text-[#E6F6CE] mb-6 flex items-center gap-3">
          <span className="h-px w-8 bg-[#E6F6CE] inline-block" /> Perché Alba
        </div>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.03] tracking-tight max-w-3xl">
          Quattro certezze per chi affida a noi la propria casa.
        </h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#F5F6F2]/10 border border-[#F5F6F2]/10 rounded-2xl overflow-hidden">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={r.title}
                data-testid={`why-us-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
                className="group bg-[#2E3131] p-8 md:p-12 hover:bg-[#3A3E3E] transition-colors duration-500"
              >
                <Icon className="text-[#E6F6CE] mb-6 group-hover:-translate-y-1 transition-transform duration-300" size={30} strokeWidth={1.4} />
                <h3 className="font-serif text-2xl md:text-3xl mb-3">{r.title}</h3>
                <p className="text-[#F5F6F2]/60 leading-relaxed" dangerouslySetInnerHTML={{ __html: r.body }} />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
